module.exports = __webpack_public_path__ + "static/media/OSAPack2.2f5dd8ce.png";